module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('modals')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62da9cc6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 745
// module chunks = 7